import { flow, get } from 'lodash/fp';
import { getModelOptions } from 'helpers/fieldOptions/car/model';
import { getSubTypeOptions } from 'helpers/fieldOptions/car/subType';

export const getModelsResult = flow(get(['result', 'wkda']), getModelOptions);

export const getSubTypesResult = flow(get(['result']), getSubTypeOptions);
